module.exports = __webpack_public_path__ + "static/media/hamburger.2d866068.svg";